import moment from 'moment';

export const enableUpdateVoucher = ({ salesPeriodEnd, canEnableSilverVouchers, canDisableSilverVouchers, payments }) => {
  const discountNotUsed = payments?.filter(({ status }) => status === 'S')?.length === 0;

  if (canEnableSilverVouchers) {
    return moment(salesPeriodEnd).isAfter(moment()) && discountNotUsed;
  }

  if (canDisableSilverVouchers) {
    return discountNotUsed;
  }

  return false;
};
